import { SET_DEST_MARKET, FORCE_UPDATE } from "../actions/dest-market-action";
import { DEFAULT_MARKETS } from "@core/utils/consts/index";

export const destMarketInitialState = {
  destMarket: DEFAULT_MARKETS.IRT,
  forceUpdate: false
};

function destMarketReducer(state = destMarketInitialState, action) {
  switch (action.type) {
    case SET_DEST_MARKET:
      const { destMarket } = action;
      return { ...state, destMarket };

    case FORCE_UPDATE:
      return { ...state, forceUpdate: !state.forceUpdate };

    default:
      console.log(`Unsupported action type: ${action.type}`);
      return state;
  }
}

export default destMarketReducer;
